module.exports = __webpack_public_path__ + "img/work5.6de53be7.png";